import {format as formatCurrency, findCurrency} from 'currency-formatter'
import formatTimeRange from './formatTimeRange'

const THOUSANDS_SEPARATOR = ' '
const DECIMAL_SEPARATOR = '.'
const {abs, pow, floor, trunc} = Math

const fraction = (number, decimalCount = 2) => {
  const base = pow(10, decimalCount)
  return (trunc(abs(number) * base) - (floor(abs(number)) * base)) % base
}
const sign = (number, showPlus = false) => number < 0 ? '-' : (showPlus ? '+' : '')
const addSpaces = string => {
  const mod = string.length > 3 ? string.length % 3 : 0
  const start = string.substring(0, mod) + (mod ? ' ' : '')
  return start + string.substr(mod).replace(/(\d{3})(?=\d)/g, '$1' + THOUSANDS_SEPARATOR)
}
const padLeft = (string, count = 2, fill = '0') => {
  return (string.length < count) ? padLeft(fill + string, count) : string
}
const stripZeros = string => string.replace(/0+$/, '')
const fractionString = value => stripZeros(padLeft(String(fraction(value))))
const significandString = value => addSpaces(String(floor(abs(value))))

export default {
  'signed-number': value => {
    return `${sign(value, true)} ${addSpaces(abs(value).toFixed(0))}`
  },
  number: value => {
    return sign(value) + addSpaces(abs(value).toFixed(0))
  },
  decimal: value => {
    const fractionPart = fractionString(value)
    const significandPart = significandString(value)
    return sign(value) + significandPart + (fractionPart ? DECIMAL_SEPARATOR + fractionPart : '')
  },
  decimalDouble: value => {
    return Number(value).toFixed(2)
  },
  'signed-decimalDouble': value => {
    return `${sign(value, true)} ${abs(value).toFixed(2)}`
  },
  'signed-percent': value => {
    const fractionPart = (value * 100).toFixed(1).split(DECIMAL_SEPARATOR)[1]
    const significandPart = significandString(value * 100)
    return sign(value, true) + significandPart + (fractionPart ? DECIMAL_SEPARATOR + fractionPart : '') + '%'
  },
  percent: value => {
    return Number(value).toLocaleString(undefined, {style: 'percent', minimumFractionDigits: 1})
  },
  doublePercent: value => {
    const fractionPart = (value * 100).toFixed(2).split(DECIMAL_SEPARATOR)[1]
    const significandPart = significandString(value * 100)
    return sign(value) + significandPart + (fractionPart ? DECIMAL_SEPARATOR + fractionPart : '') + '%'
  },
  currency: (amount, currency) => {
    return formatCurrency(amount, {
      ...findCurrency(currency),
      precision: 2,
      thousand: THOUSANDS_SEPARATOR,
      decimal: DECIMAL_SEPARATOR
    })
  },
  seconds: seconds => {
    return formatTimeRange(seconds * 1000)
  }
}



// WEBPACK FOOTER //
// ./client/utils/numberFormats.js